import React from 'react';
import "./style.scss"

const LoadingTable = () => {
    return (
        <>
            <div className="main-loading-cube">
                <div className="cube">
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                    <div className="side"></div>
                </div>
            </div>
        </>
    )
}
export default LoadingTable